module.exports = __webpack_public_path__ + "static/media/horrormax-banner-skyquake.82c4f27a.jpg";